/* TODO: render issue fix on mobile device */
import { useEffect, useState } from 'react';

const getWindowSize = () => {
  if (typeof window === 'undefined') return { width: 0, height: 0 };
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  };
};

const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowSize);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    let animationFrameId;

    const handleResize = () => {
      animationFrameId = window.requestAnimationFrame(() => {
        const { width, height } = getWindowSize();
        setWindowDimensions((prev) => {
          if (prev.width !== width || prev.height !== height) {
            return { width, height };
          }
          return prev;
        });
      });
    };

    // Delay initial update to allow layout to stabilize
    handleResize();

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (animationFrameId) {
        window.cancelAnimationFrame(animationFrameId);
      }
    };
  }, []);

  return windowDimensions;
};

export default useWindowDimensions;
